import React, { useContext, useMemo, useState } from 'react'
import { Template } from '../../components/template'
import { HeaderV2 } from '../../components/HeaderV2'
import CardRequest from './components/card-request'
import { TemplateContext } from '../../components/template/context'

import * as S from './styles'
import StatusChip from './components/status-badge/index'
import { useRequests } from './hooks'

const Requests = () => {
  const { selectCrid, isMobile } = useContext(TemplateContext)
  const { refundFlowStatus, cancellationData, refetchCancellationData } = useRequests({ cridInfo: selectCrid })
  const [openMap, setOpenMap] = useState({ main: true })

  const items = useMemo(
    () => [
      {
        id: 'main',
        status: refundFlowStatus,
        cancellationStatus: cancellationData?.cancellationRequest?.status,
        title: 'Solicitação de cancelamento',
        render: () => <CardRequest cridInfo={selectCrid} isMobile={isMobile} refetchParentData={refetchCancellationData} />
      }
    ],
    [selectCrid, isMobile, refundFlowStatus, cancellationData, refetchCancellationData]
  )

  const toggle = id => setOpenMap(m => ({ ...m, [id]: !m[id] }))

  return (
    <Template>
      <HeaderV2 label="Solicitações" />

      <S.ContainerRequests>
        <S.Accordion>
          {items.map(it => {
            const open = !!openMap[it.id]
            return (
              <S.AccordionItem key={it.id}>
                <S.AccordionHeader onClick={() => toggle(it.id)} aria-expanded={open}>
                  <S.HeaderLeft>
                    <h3>{it.title}</h3>
                  </S.HeaderLeft>

                  <S.HeaderActions>
                    <StatusChip status={it.status} cancellationStatus={it.cancellationStatus} />
                    <span className="action-link">{open ? 'Fechar' : 'Abrir'}</span>
                    <S.Chevron $open={open} />
                  </S.HeaderActions>
                </S.AccordionHeader>

                <S.AccordionContent $open={open}>{it.render()}</S.AccordionContent>
              </S.AccordionItem>
            )
          })}
        </S.Accordion>
      </S.ContainerRequests>
    </Template>
  )
}

export default Requests
